import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.from-entries";
import { createMedia } from '@artsy/fresnel';
import { breakpoints } from './breakpoints';
var AppMedia = createMedia({
  breakpoints: Object.fromEntries(breakpoints)
});
export var mediaStyle = AppMedia.createMediaStyle();
var Media = AppMedia.Media,
    MediaContextProvider = AppMedia.MediaContextProvider;
export { Media, MediaContextProvider };